import { SimpleModal, SimpleModalVariant } from "@repo/ui/Modal/modal";
import { showToast, ToastVariant } from "@repo/ui/toast/toast";
import { nanoid } from "nanoid";
import { type FC, useState } from "react";
import { updateProject } from "../features/projects/projectsSlice.js";
import { useAppDispatch } from "../hooks/hook.js";

interface RegenerateInterviewLinkModalProps {
  isOpen: boolean;
  onClose: () => void;
  projectId: string;
  inviteLinkUrl: string;
}

export const RegenerateInterviewLinkModal: FC<
  RegenerateInterviewLinkModalProps
> = ({ isOpen, onClose, projectId, inviteLinkUrl }) => {
  const dispatch = useAppDispatch();
  const [isInterviewLinkSaveInProgress, setIsInterviewLinkSaveInProgress] =
    useState(false);

  const handleRegenerateInterviewLink = async () => {
    setIsInterviewLinkSaveInProgress(true);
    try {
      await dispatch(
        updateProject({
          projectId,
          changes: {
            short_id: nanoid(),
          },
        }),
      );

      showToast({
        title: `Interview link refreshed`,
        variant: ToastVariant.Success,
      });

      onClose();
    } catch (err) {
      console.error("error regenerating interview link", err);
      showToast({
        title: `Failed to refresh interview link`,
        variant: ToastVariant.Error,
      });
    } finally {
      setIsInterviewLinkSaveInProgress(false);
    }
  };

  return (
    <SimpleModal
      isOpen={isOpen}
      variant={SimpleModalVariant.Warning}
      title="Refresh interview link"
      subtitle={`If you continue, your current link (${inviteLinkUrl}) will be disabled, and a new link will be generated. Interviews already conducted using the old link will be preserved.`}
      confirmButtonText="Refresh link"
      onCancel={() => {
        onClose();
      }}
      onConfirm={() => {
        void handleRegenerateInterviewLink();
      }}
      isPrimaryButtonLoading={isInterviewLinkSaveInProgress}
    />
  );
};
